angular.module('unergie.main')
.controller('clientsCtrl', ($scope, $state, $location, $stateParams, AccountService, AlertManager, DataAccess, StringUtils,
    ReferencesService, TableGeneratorService, BoFeaturesService, ErrorCatcher, ApiUser, AuthService) => {
    $scope.canUserInfo = BoFeaturesService.isFeatureOn('userInfo')

    $scope.clients = {
        show: {},
    }
    $scope.clients.refreshing = false

    $scope.clients.columns = {
        id: { label: 'Id', mode: 'search_wildcard', length: 36 },
        customer_id: { label: 'Statut', mode: 'search_wildcard', length: 9 },
        owner: { label: 'Propriétaire', mode: 'search_wildcard', transform: StringUtils.unaccent },
        fullname: { label: 'Nom', mode: 'search_wildcard' },
        fullname2: { label: '2ème Nom', mode: 'hidden' },
        mail: { label: 'Email', mode: 'search_wildcard' },
        phone: { label: 'Téléphone', mode: 'search_wildcard' },
        creation_ts: { label: 'Date inscription', mode: 'search_date' },
        status: { label: 'Statut', mode: 'filter_only', debounce: 0 },
        ignored: { label: 'Actions', mode: 'search_strict', title: "Ignoré: 'true' ou 'false'" },
        active: { label: 'Actif', mode: 'hidden' },
    }

    if ($stateParams.name || $stateParams.mail) {
        $scope.clients.instance = {}
        $scope.clients.instance.page = () => 1
        $scope.clients.instance.count = () => 25
        $scope.clients.instance.sorting = () => ({})
        $scope.clients.instance.filter = () => _.assign(_.clone($location.search()), _.pickBy({ owner: $stateParams.name }))
    }

    const refresh = () => TableGeneratorService.getTable($scope.clients, 'accounts', 'contractsCommon', null, { null: ['organization'], orderBy: '-creation_ts' })

    $scope.refresh = refresh
    refresh()

    $scope.showAdd = () => AuthService.userHasGroup('data-admin')

    $scope.idAdmin = () => AuthService.userHasGroup(['data-admin', 'data-reader'])

    $scope.isActive = (state) => $state.is(state)

    const userTemplate = {
        email: '',
        civ: 'M.',
        givenName: undefined,
        sn: undefined,
    }
    $scope.userFields = {
        email: {
            label: 'E-mail',
            required: true,
            type: 'email',
        },
        givenName: {
            label: 'Prénom',
            required: true,
            type: 'text',
        },
        sn: {
            label: 'Nom de famille',
            required: true,
            type: 'text',
        },
        civ: {
            label: 'Civilité',
            type: 'select',
            enum: [{
                value: 'M.',
                label: 'M.',
            },
            {
                value: 'Mme',
                label: 'Mme',
            }],
        },
    }

    const resetUserPayload = () => ($scope.userPayload = angular.copy(userTemplate))

    resetUserPayload()

    $scope.new = () =>
        ApiUser.newEndUser($scope.userPayload).$promise.then((data) => {
            refresh()
            return resetUserPayload()
        }).catch(ErrorCatcher)


    $scope.toggleIgnore = (account) =>
        ApiUser.updateAccount({ id_account: account.id }, { ignored: !account.ignored }).$promise.then((result) => {
            AlertManager.success(account.ignored ? 'Compte dé-ignoré' : 'Compte ignoré')
            return refresh()
        }).catch(ErrorCatcher)
})
